export interface ConditionalProps {
  isShow: boolean | 'pending';
  children: React.ReactNode;
}

const Conditional: React.FC<ConditionalProps> = (props) => {
  const { isShow, children } = props;
  return (isShow && isShow !== 'pending') ? <>{children}</> : null;
}

export default Conditional;